export function watchMediaQuery(
  fn: (match:boolean) => void,
  value = '(max-width: 599px)',
  global = window,
): () => void {
  if (!('matchMedia' in global)) {
    return;
  }
  try {
    const query = global.matchMedia(value);
    fn(query.matches);
    const callback = ({matches}: {matches: boolean}) => fn(matches);
    if (query.addEventListener !== undefined) {
      query.addEventListener('change', callback);
      return () => query.removeEventListener('change', callback);
    }
    // safari prior 14
    if (query.addListener !== undefined) {
      query.addListener(callback);
      return () => query.removeListener(callback);
    }
  } catch (e) {
    console.error(e);
    return () => null;
  }
}
